import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";
import {
  MenuItemsForDropDown,
  NameField,
  SurnameField,
  IDTypeSelectComponent,
  TaxTypeSelectComponent,
  TaxNumberComponent,
  IDNumberComponent,
  EmailFieldComponent,
  PassportComponent,
} from "@soqs/common";

import { useSelector } from "react-redux";
import {
  dropdownopts,
  dropdownsloading,
  formState,
} from "../../features/AppSlice";

import SelectComponent from "./usercomponents/SelectComponent";
import DateSelectorComponent from "./usercomponents/DateSelectorComponent";
import PostalCode from "./usercomponents/Address/PostalCodeComponent";
import AddressUnitNumber from "./usercomponents/Address/AddressUnitNumber";
import AddressComplexName from "./usercomponents/Address/AddressComplexName";
import AddressStreetName from "./usercomponents/Address/AddressStreetName";
import AddressSuburb from "./usercomponents/Address/AddressSuburbComponent";
import AddressCity from "./usercomponents/Address/AddressCityComponent";
import TrustsMobileField from "./usercomponents/TrustsMobileField";
import BODescription from "./usercomponents/BODescription";
import VATNumberComponent from "./usercomponents/VATNumber/VATNumberComponent";

const BOEntityRepDetails = (props) => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const formData = useSelector(formState);

  const unnamedNotRequired =
    formData.values?.bo_entities[props.entityindex].bo_entity_representatives[
      props.index
    ].bo_entity_representative_unnamed === true
      ? false
      : true;

  return formData.values?.bo_entities[props.entityindex]
    .bo_entity_representatives[props.index].bo_entity_representative_unnamed !==
    true ? (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Button>
          <u>{`Representative ${props.index + 1}`}</u>
        </Button>
        <NameField
          index={props.index}
          label="Name"
          name={`${props.name}.bo_entity_representative_name`}
          aria-label={`Entity Representative ${props.index + 1}: Name`}
          required={unnamedNotRequired}
        />
        <SurnameField
          label="Surname"
          name={`${props.name}.bo_entity_representative_surname`}
          aria-label={`Entity Representative ${props.index + 1}: Surname`}
          required={unnamedNotRequired}
        />
        {formData.values?.bo_entities[props.entityindex]
          .bo_entity_representatives[props.index]
          .bo_entity_representative_collapsed ? null : (
          <>
            <SelectComponent
              label="Place of Birth"
              name={`${props.name}.bo_entity_representative_placeofbirth`}
              aria-label={`Entity Representative ${
                props.index + 1
              }: Place of Birth`}
              required={unnamedNotRequired}
              options={MenuItemsForDropDown("country", dropdownoptions, false)}
              optionsloading={dropdownloading}
            />
            <SelectComponent
              label="Country of Residence"
              name={`${props.name}.bo_entity_representative_country`}
              aria-label={`Entity Representative ${
                props.index + 1
              }: Country of Residence`}
              required={unnamedNotRequired}
              options={MenuItemsForDropDown("country", dropdownoptions, false)}
              optionsloading={dropdownloading}
            />
            {formData.values.bo_entities[props.entityindex]
              .bo_entity_representatives[props.index]
              .bo_entity_representative_idtype === "1" ? (
              <>
                <IDTypeSelectComponent
                  name={`${props.name}.bo_entity_representative_idtype`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }:ID Type`}
                  idoptions={MenuItemsForDropDown("idtype", dropdownoptions)}
                  optionsloading={dropdownloading}
                />
                <IDNumberComponent
                  name={`${props.name}.bo_entity_representative_idnumber`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: ID Number`}
                />
                {formData.values.bo_entities[props.entityindex]
                  .bo_entity_representatives[props.index]
                  .bo_entity_representative_taxtype !== "99" ? (
                  <>
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_representative_taxtype`}
                      aria-label={`Entity Representative ${
                        props.index + 1
                      }: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_bo_entity_with_no_reg",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                    {formData.values.bo_entities[props.entityindex]
                      .bo_entity_representatives[props.index]
                      .bo_entity_representative_taxtype === "1" ? (
                      <TaxNumberComponent
                        name={`${props.name}.bo_entity_representative_taxnumber`}
                        aria-label={`Entity Representative ${
                          props.index + 1
                        }: Tax Number`}
                      />
                    ) : null}
                    {formData.values.bo_entities[props.entityindex]
                      .bo_entity_representatives[props.index]
                      .bo_entity_representative_taxtype === "3" ? (
                      <VATNumberComponent
                        name={`${props.name}.bo_entity_representative_taxnumber`}
                        label="Vat Number"
                        aria-label={`Entity Representative ${
                          props.index + 1
                        }: VAT Number`}
                      />
                    ) : null}
                  </>
                ) : (
                  <TaxTypeSelectComponent
                    name={`${props.name}.bo_entity_representative_taxtype`}
                    aria-label={`Entity Representative ${
                      props.index + 1
                    }: Tax Type`}
                    taxoptions={MenuItemsForDropDown(
                      "taxtype_bo_entity_with_no_reg",
                      dropdownoptions
                    )}
                    optionsloading={dropdownloading}
                  />
                )}
                <SelectComponent
                  label="Tax Juristiction"
                  name={`${props.name}.bo_entity_representative_taxjuristiction`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Tax Juristiction`}
                  required={unnamedNotRequired}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <SelectComponent
                  label="Mobile Code"
                  name={`${props.name}.bo_entity_representative_mobilecode`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Mobile Code`}
                  required={unnamedNotRequired}
                  options={MenuItemsForDropDown(
                    "mobilecode",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <TrustsMobileField
                  name={`${props.name}.bo_entity_representative_mobile`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Mobile Number`}
                  required={unnamedNotRequired}
                  label="Mobile Number"
                />
                <EmailFieldComponent
                  name={`${props.name}.bo_entity_representative_email`}
                  aria-label={`Entity Representative ${props.index + 1}: Email`}
                />
                <AddressUnitNumber
                  name={`${props.name}.bo_entity_representative_unitno`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Unit Number`}
                  label="Unit Number"
                />
                <AddressComplexName
                  name={`${props.name}.bo_entity_representative_complexname`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Complex Name`}
                  label="Complex Name"
                />
                <AddressStreetName
                  name={`${props.name}.bo_entity_representative_streetname`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Street`}
                  label="Street"
                  required={true}
                />
                <AddressSuburb
                  name={`${props.name}.bo_entity_representative_suburb`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Suburb/District`}
                  label="Suburb/District"
                  required={unnamedNotRequired}
                  autoComplete="address-level3"
                />
                <AddressCity
                  name={`${props.name}.bo_entity_representative_city`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: City/Town`}
                  label="City/Town"
                  required={unnamedNotRequired}
                  autoComplete="address-level2"
                />
                <PostalCode
                  name={`${props.name}.bo_entity_representative_postalcode`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Postal Code`}
                  label="Postal Code"
                  required={unnamedNotRequired}
                  autoComplete="postal-code"
                />
              </>
            ) : (
              <>
                <IDTypeSelectComponent
                  name={`${props.name}.bo_entity_representative_idtype`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: ID Type`}
                  idoptions={MenuItemsForDropDown("idtype", dropdownoptions)}
                  optionsloading={dropdownloading}
                />
                <PassportComponent
                  name={`${props.name}.bo_entity_representative_passport`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Passport Number`}
                  label="Passport Number"
                />
                <DateSelectorComponent
                  name={`${props.name}.bo_entity_representative_passportdt`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Issue Date`}
                  label="Issue Date"
                  readonly={true}
                  maxDate={new Date(Date.now())}
                />
                <SelectComponent
                  label="Passport Country"
                  name={`${props.name}.bo_entity_representative_passportcountry`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Passport Country`}
                  required={unnamedNotRequired}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <SelectComponent
                  label="Tax Juristiction"
                  name={`${props.name}.bo_entity_representative_taxjuristiction`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Tax Juristiction`}
                  required={unnamedNotRequired}
                  options={MenuItemsForDropDown(
                    "country",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                {formData.values.bo_entities[props.entityindex]
                  .bo_entity_representatives[props.index]
                  .bo_entity_representative_taxtype !== "99" ? ( //Not Registered
                  <>
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_representative_taxtype`}
                      aria-label={`Entity Representative ${
                        props.index + 1
                      }: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_bo_entity_with_no_reg",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                    {formData.values.bo_entities[props.entityindex]
                      .bo_entity_representatives[props.index]
                      .bo_entity_representative_taxtype === "1" ? (
                      <TaxNumberComponent
                        name={`${props.name}.bo_entity_representative_taxnumber`}
                        aria-label={`Entity Representative ${
                          props.index + 1
                        }: Tax Number`}
                      />
                    ) : null}
                    {formData.values.bo_entities[props.entityindex]
                      .bo_entity_representatives[props.index]
                      .bo_entity_representative_taxtype === "3" ? (
                      <VATNumberComponent
                        name={`${props.name}.bo_entity_representative_taxnumber`}
                        label="Vat Number"
                        aria-label={`Entity Representative ${
                          props.index + 1
                        }: VAT Number`}
                      />
                    ) : null}
                    <EmailFieldComponent
                      name={`${props.name}.bo_entity_representative_email`}
                      aria-label={`Entity Representative ${
                        props.index + 1
                      }: EMail`}
                    />
                  </>
                ) : (
                  <>
                    <TaxTypeSelectComponent
                      name={`${props.name}.bo_entity_representative_taxtype`}
                      aria-label={`Entity Representative ${
                        props.index + 1
                      }: Tax Type`}
                      taxoptions={MenuItemsForDropDown(
                        "taxtype_bo_entity_with_no_reg",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                    <EmailFieldComponent
                      name={`${props.name}.bo_entity_representative_email`}
                      aria-label={`Entity Representative ${
                        props.index + 1
                      }: Email`}
                    />
                  </>
                )}
                <SelectComponent
                  label="Mobile Code"
                  name={`${props.name}.bo_entity_representative_mobilecode`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Mobile Code`}
                  required={unnamedNotRequired}
                  options={MenuItemsForDropDown(
                    "mobilecode",
                    dropdownoptions,
                    false
                  )}
                  optionsloading={dropdownloading}
                />
                <TrustsMobileField
                  name={`${props.name}.bo_entity_representative_mobile`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Mobile Number`}
                  required={unnamedNotRequired}
                  label="Mobile Number"
                />
                <AddressUnitNumber
                  name={`${props.name}.bo_entity_representative_unitno`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Unit Number`}
                  label="Unit Number"
                />
                <AddressComplexName
                  name={`${props.name}.bo_entity_representative_complexname`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Complex Name`}
                  label="Complex Name"
                />
                <AddressStreetName
                  name={`${props.name}.bo_entity_representative_streetname`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Street`}
                  label="Street"
                  required={true}
                />
                <AddressSuburb
                  name={`${props.name}.bo_entity_representative_suburb`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Suburb/District`}
                  label="Suburb/District"
                  required={unnamedNotRequired}
                  autoComplete="address-level3"
                />
                <AddressCity
                  name={`${props.name}.bo_entity_representative_city`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: City/Town`}
                  label="City/Town"
                  required={unnamedNotRequired}
                  autoComplete="address-level2"
                />
                <PostalCode
                  name={`${props.name}.bo_entity_representative_postalcode`}
                  aria-label={`Entity Representative ${
                    props.index + 1
                  }: Postal Code`}
                  label="Postal Code"
                  required={unnamedNotRequired}
                  autoComplete="postal-code"
                />
              </>
            )}
          </>
        )}
      </Box>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <TableContainer>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <Button>
                    <u>{`Representative ${props.index + 1}`}</u>
                  </Button>
                </TableCell>
                <TableCell colSpan={6}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <NameField
                    index={props.index}
                    label="Name"
                    name={`${props.name}.bo_entity_representative_name`}
                    aria-label={`Entity Representative ${
                      props.index + 1
                    }: Name`}
                    required={unnamedNotRequired}
                  />
                </TableCell>
                <TableCell>
                  <SurnameField
                    label="Surname"
                    name={`${props.name}.bo_entity_representative_surname`}
                    aria-label={`Entity Representative ${
                      props.index + 1
                    }: Surname`}
                    required={unnamedNotRequired}
                  />
                </TableCell>
                <TableCell>
                  <SelectComponent
                    label="Place of Birth"
                    name={`${props.name}.bo_entity_representative_placeofbirth`}
                    aria-label={`Entity Representative ${
                      props.index + 1
                    }: Place of Birth`}
                    required={unnamedNotRequired}
                    options={MenuItemsForDropDown(
                      "country",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                </TableCell>
                <TableCell>
                  <SelectComponent
                    label="Country of Residence"
                    name={`${props.name}.bo_entity_representative_country`}
                    aria-label={`Entity Representative ${
                      props.index + 1
                    }: Country of Residence`}
                    required={unnamedNotRequired}
                    options={MenuItemsForDropDown(
                      "country",
                      dropdownoptions,
                      false
                    )}
                    optionsloading={dropdownloading}
                  />
                </TableCell>
              </TableRow>
              {formData.values?.bo_entities[props.entityindex]
                .bo_entity_representatives[props.index]
                .bo_entity_representative_collapsed ? null : (
                <>
                  {formData.values.bo_entities[props.entityindex]
                    .bo_entity_representatives[props.index]
                    .bo_entity_representative_idtype === "1" ? (
                    <>
                      <TableRow>
                        <TableCell>
                          <IDTypeSelectComponent
                            name={`${props.name}.bo_entity_representative_idtype`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: ID Type`}
                            idoptions={MenuItemsForDropDown(
                              "idtype",
                              dropdownoptions
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <IDNumberComponent
                            name={`${props.name}.bo_entity_representative_idnumber`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: ID Number`}
                          />
                        </TableCell>
                        {formData.values.bo_entities[props.entityindex]
                          .bo_entity_representatives[props.index]
                          .bo_entity_representative_taxtype !== "99" ? (
                          <>
                            <TableCell>
                              <TaxTypeSelectComponent
                                name={`${props.name}.bo_entity_representative_taxtype`}
                                aria-label={`Entity Representative ${
                                  props.index + 1
                                }: Tax Type`}
                                taxoptions={MenuItemsForDropDown(
                                  "taxtype_bo_entity_with_no_reg",
                                  dropdownoptions
                                )}
                                optionsloading={dropdownloading}
                              />
                            </TableCell>
                            {formData.values.bo_entities[props.entityindex]
                              .bo_entity_representatives[props.index]
                              .bo_entity_representative_taxtype === "1" ? (
                              <TableCell>
                                <TaxNumberComponent
                                  name={`${props.name}.bo_entity_representative_taxnumber`}
                                  aria-label={`Entity Representative ${
                                    props.index + 1
                                  }: Tax Number`}
                                />
                              </TableCell>
                            ) : null}
                            {formData.values.bo_entities[props.entityindex]
                              .bo_entity_representatives[props.index]
                              .bo_entity_representative_taxtype === "3" ? (
                              <TableCell>
                                <VATNumberComponent
                                  name={`${props.name}.bo_entity_representative_taxnumber`}
                                  aria-label={`Entity Representative ${
                                    props.index + 1
                                  }: VAT Number`}
                                />
                              </TableCell>
                            ) : null}
                          </>
                        ) : (
                          <TableCell colSpan={2}>
                            <TaxTypeSelectComponent
                              name={`${props.name}.bo_entity_representative_taxtype`}
                              aria-label={`Entity Representative ${
                                props.index + 1
                              }: Tax Type`}
                              taxoptions={MenuItemsForDropDown(
                                "taxtype_bo_entity_with_no_reg",
                                dropdownoptions
                              )}
                              optionsloading={dropdownloading}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <SelectComponent
                            label="Tax Juristiction"
                            name={`${props.name}.bo_entity_representative_taxjuristiction`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Tax Juristiction`}
                            required={unnamedNotRequired}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <SelectComponent
                            label="Mobile Code"
                            name={`${props.name}.bo_entity_representative_mobilecode`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Mobile Code`}
                            required={unnamedNotRequired}
                            options={MenuItemsForDropDown(
                              "mobilecode",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <TrustsMobileField
                            name={`${props.name}.bo_entity_representative_mobile`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Mobile Number`}
                            required={unnamedNotRequired}
                            label="Mobile Number"
                          />
                        </TableCell>
                        <TableCell>
                          <EmailFieldComponent
                            name={`${props.name}.bo_entity_representative_email`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Email`}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <AddressUnitNumber
                            name={`${props.name}.bo_entity_representative_unitno`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Unit Number`}
                            label="Unit Number"
                          />
                        </TableCell>
                        <TableCell>
                          <AddressComplexName
                            name={`${props.name}.bo_entity_representative_complexname`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Complex Name`}
                          />
                        </TableCell>
                        <TableCell>
                          <AddressStreetName
                            name={`${props.name}.bo_entity_representative_streetname`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Street`}
                            label="Street"
                            required={true}
                          />
                        </TableCell>
                        <TableCell>
                          <AddressSuburb
                            name={`${props.name}.bo_entity_representative_suburb`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Suburb/District`}
                            label="Suburb/District"
                            required={unnamedNotRequired}
                            autoComplete="address-level3"
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <AddressCity
                            name={`${props.name}.bo_entity_representative_city`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: City/Town`}
                            label="City/Town"
                            required={unnamedNotRequired}
                            autoComplete="address-level2"
                          />
                        </TableCell>
                        <TableCell>
                          <PostalCode
                            name={`${props.name}.bo_entity_representative_postalcode`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Postal Code`}
                            label="Postal Code"
                            required={unnamedNotRequired}
                            autoComplete="postal-code"
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell>
                          <IDTypeSelectComponent
                            name={`${props.name}.bo_entity_representative_idtype`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: ID Type`}
                            idoptions={MenuItemsForDropDown(
                              "idtype",
                              dropdownoptions
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <PassportComponent
                            name={`${props.name}.bo_entity_representative_passport`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Passport Number`}
                            label="Passport Number"
                          />
                        </TableCell>
                        <TableCell>
                          <DateSelectorComponent
                            name={`${props.name}.bo_entity_representative_passportdt`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Issue Date`}
                            label="Issue Date"
                            readonly={true}
                            maxDate={new Date(Date.now())}
                          />
                        </TableCell>
                        <TableCell>
                          <SelectComponent
                            label="Passport Country"
                            name={`${props.name}.bo_entity_representative_passportcountry`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Passport Country`}
                            required={unnamedNotRequired}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <SelectComponent
                            label="Tax Juristiction"
                            name={`${props.name}.bo_entity_representative_taxjuristiction`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Tax Juristiction`}
                            required={unnamedNotRequired}
                            options={MenuItemsForDropDown(
                              "country",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        {formData.values.bo_entities[props.entityindex]
                          .bo_entity_representatives[props.index]
                          .bo_entity_representative_taxtype !== "99" ? (
                          <>
                            <TableCell>
                              <TaxTypeSelectComponent
                                name={`${props.name}.bo_entity_representative_taxtype`}
                                aria-label={`Entity Representative ${
                                  props.index + 1
                                }: Tax Type`}
                                taxoptions={MenuItemsForDropDown(
                                  "taxtype_bo_entity_with_no_reg",
                                  dropdownoptions
                                )}
                                optionsloading={dropdownloading}
                              />
                            </TableCell>

                            {formData.values.bo_entities[props.entityindex]
                              .bo_entity_representatives[props.index]
                              .bo_entity_representative_taxtype === "1" ? (
                              <TableCell>
                                <TaxNumberComponent
                                  name={`${props.name}.bo_entity_representative_taxnumber`}
                                  aria-label={`Entity Representative ${
                                    props.index + 1
                                  }: Tax Number`}
                                />
                              </TableCell>
                            ) : null}
                            {formData.values.bo_entities[props.entityindex]
                              .bo_entity_representatives[props.index]
                              .bo_entity_representative_taxtype === "3" ? (
                              <TableCell>
                                <VATNumberComponent
                                  name={`${props.name}.bo_entity_representative_taxnumber`}
                                  label="VAT Number"
                                  aria-label={`Entity Representative ${
                                    props.index + 1
                                  }: VAT Number`}
                                />
                              </TableCell>
                            ) : null}

                            <TableCell>
                              <EmailFieldComponent
                                name={`${props.name}.bo_entity_representative_email`}
                                aria-label={`Entity Representative ${
                                  props.index + 1
                                }: EMail`}
                              />
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>
                              <TaxTypeSelectComponent
                                name={`${props.name}.bo_entity_representative_taxtype`}
                                aria-label={`Entity Representative ${
                                  props.index + 1
                                }: Tax Type`}
                                taxoptions={MenuItemsForDropDown(
                                  "taxtype_bo_entity_with_no_reg",
                                  dropdownoptions
                                )}
                                optionsloading={dropdownloading}
                              />
                            </TableCell>
                            <TableCell colSpan={2}>
                              <EmailFieldComponent
                                name={`${props.name}.bo_entity_representative_email`}
                                aria-label={`Entity Representative ${
                                  props.index + 1
                                }: Email`}
                              />
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <SelectComponent
                            label="Mobile Code"
                            name={`${props.name}.bo_entity_representative_mobilecode`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Mobile Code`}
                            required={unnamedNotRequired}
                            options={MenuItemsForDropDown(
                              "mobilecode",
                              dropdownoptions,
                              false
                            )}
                            optionsloading={dropdownloading}
                          />
                        </TableCell>
                        <TableCell>
                          <TrustsMobileField
                            name={`${props.name}.bo_entity_representative_mobile`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Mobile Number`}
                            required={unnamedNotRequired}
                            label="Mobile Number"
                          />
                        </TableCell>
                        <TableCell>
                          <AddressUnitNumber
                            name={`${props.name}.bo_entity_representative_unitno`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Unit Number`}
                            label="Unit Number"
                          />
                        </TableCell>
                        <TableCell>
                          <AddressComplexName
                            name={`${props.name}.bo_entity_representative_complexname`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Complex Name`}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <AddressStreetName
                            name={`${props.name}.bo_entity_representative_streetname`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Street`}
                            label="Street"
                            required={true}
                          />
                        </TableCell>
                        <TableCell>
                          <AddressSuburb
                            name={`${props.name}.bo_entity_representative_suburb`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Suburb/District`}
                            label="Suburb/District"
                            required={unnamedNotRequired}
                            autoComplete="address-level3"
                          />
                        </TableCell>
                        <TableCell>
                          <AddressCity
                            name={`${props.name}.bo_entity_representative_city`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: City/Town`}
                            label="City/Town"
                            required={unnamedNotRequired}
                            autoComplete="address-level2"
                          />
                        </TableCell>
                        <TableCell>
                          <PostalCode
                            name={`${props.name}.bo_entity_representative_postalcode`}
                            aria-label={`Entity Representative ${
                              props.index + 1
                            }: Postal Code`}
                            label="Postal Code"
                            required={unnamedNotRequired}
                            autoComplete="postal-code"
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  ) : (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Button>
          <u>{`Representative  ${props.index + 1} (UNNAMED)`}</u>
        </Button>
        <SelectComponent
          label="Beneficial Ownership Category"
          name={`${props.name}.bo_entity_representative_unnamed_category`}
          aria-label={`Entity ${props.index + 1}: Entity Type`}
          required={!unnamedNotRequired}
          options={MenuItemsForDropDown("bocategory", dropdownoptions, false)}
        />
        <BODescription
          name={`${props.name}.bo_entity_representative_unnamed_description`}
          aria-label={`Individual ${props.index + 1}: Description`}
          label="Description"
        />
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <TableContainer>
          <Table sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell colSpan={6}>
                  <Button>
                    <u>{`Representative  ${props.index + 1} (UNNAMED)`}</u>
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}>
                  <SelectComponent
                    label="Beneficial Ownership Category"
                    name={`${props.name}.bo_entity_representative_unnamed_category`}
                    aria-label={`Individual ${
                      props.index + 1
                    }: Beneficial Ownership Category`}
                    required={!unnamedNotRequired}
                    options={MenuItemsForDropDown(
                      "bocategory",
                      dropdownoptions,
                      false
                    )}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}>
                  <BODescription
                    name={`${props.name}.bo_entity_representative_unnamed_description`}
                    aria-label={`Individual ${props.index + 1}: Description`}
                    label="Description"
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default BOEntityRepDetails;
